import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import AddSliderContentComponent from './AddSliderContentComponent';

class AddSliderComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <AddSliderContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default AddSliderComponent;